module.exports = __webpack_public_path__ + "static/media/Img1.c27b3c40.png";